module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buyBackTitle":"提现记录","buyBackTime":"发起时间（UTC）","buyBackAmount":"回购数量"},"zn":{"buyBackTitle":"提现记录","buyBackTime":"发起时间（UTC）","buyBackAmount":"回购数量"}}')
  delete Component.options._Ctor
}
